export const CREATE_STORE_QUERY_PARAMS = [
    'ref',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
] as const;

type UtmParam = Exclude<(typeof CREATE_STORE_QUERY_PARAMS)[number], 'ref'>;

export const CREATE_STORE_UTM_PARAMS = CREATE_STORE_QUERY_PARAMS.filter((p): p is UtmParam => p !== 'ref');
